
import utils from './../../utils';

export class ItemRequest {
    categoryDescription: string;
    id: string;
    name: string;
    location: string;
    isQuantityOfAllLocations: boolean;
    itemBarCode: string;

    constructor() {
        this.name = '';
        this.categoryDescription = '';
        this.id = '';
        this.location = utils.getLocation();
        this.isQuantityOfAllLocations = utils.getShowQuantityOfAllLocations();
    }
}